let mainPath = "/reporting";
let viewFolder = "Reporting";

module.exports = [
    {
        path: mainPath,
        name: 'reporting',
        component: () => import('../views/'+viewFolder+'/Index.vue')
    },
    {
        path: mainPath+'/tailorCosts',
        name: 'tailorcosts',
        component: () => import('../views/'+viewFolder+'/TailorCosts.vue')
    },
    {
        path: mainPath+'/:customReport',
        name: 'CustomReport',
        component: () => import('../views/'+viewFolder+'/CustomReport.vue')
    }
]